module.exports = __webpack_public_path__ + "img/spartan-masonry-concrete-tile-05-xlarge.103cccbf.jpg";